export default __webpack_public_path__ + "static/media/dg.fa1dcf1b.png";